import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicationService } from '../../../../core/services/application.service';
import { NodeService } from '../../../../core/services/node.service';

@Component({
  selector: 'app-set-nodegroup-vm',
  templateUrl: './set-nodegroup-vm.component.html',
  styleUrls: ['./set-nodegroup-vm.component.scss']
})
export class SetNodegroupVmComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { nodeGroups: [], vmNodeGroups: string, depName: string, nodeName: string },
    public dialog: MatDialogRef<SetNodegroupVmComponent>,
    private snackBar: MatSnackBar,
    private nodeService: NodeService,
    private applicationService: ApplicationService
  ) { }

  nodeGroups = [];
  assigned = [];

  messages = [];

  ngOnInit() {
    if (this.data.nodeGroups.length == 0) {
      this.getNodeGroup();
    }
    else {
      this.nodeGroups = this.data.nodeGroups;
    }
    if (this.data.vmNodeGroups.length != 0) {
      this.assigned = this.data.vmNodeGroups.split(',');
    }
  }

  checked(item) {
    if (this.assigned.indexOf(item) != -1) {
      return true;
    }
  }

  onChange(checked, item) {
    if (checked) {
      this.assigned.push(item);
    } else {
      this.assigned.splice(this.assigned.indexOf(item), 1)
    }
  }

  save() {
    if (this.assigned.length == 0) {
      this.assigned.push('Default');
    }
    this.nodeService.setNodeGroup(this.data.depName, this.data.nodeName, this.assigned.toString())
      .subscribe({
        next: (data: any) => {
          this.snackBar.open(data.message, 'Ok', { duration: 5000 });
        },
        error: (err: any) => {
          this.snackBar.open(err.error.message, 'Ok', { duration: 5000 });
        }
      });
      this.dialog.close(this.assigned.toString());
    }

  onClose() {
    this.dialog.close(false);
  }

  getNodeGroup() {
    this.applicationService.getNodeGroupsForDeployment(this.data.depName)
      .subscribe((data) => {
        this.nodeGroups = <string[]>JSON.parse(JSON.stringify(data));
      });
  }
}
